import { httpClient } from "@/services/http/client";

export async function enrollInFreeCourse(courseId: string): Promise<{ enrolled: boolean }> {
  const res = await httpClient.post<{ data: { enrolled: boolean } }>(
    `/v1/courses/${courseId}/enroll`,
  );
  return res.data.data;
}

export async function joinCourseWaitlist(
  courseId: string,
  input: { email: string; name?: string },
): Promise<void> {
  await httpClient.post(`/v1/courses/${courseId}/waitlist`, input);
}

export type CourseReview = {
  id: string;
  authorName: string;
  rating: number;
  body: string | null;
  createdAt: string;
};

export type CourseReviewSummary = {
  count: number;
  averageRating: number;
};

export async function fetchCourseReviews(courseId: string): Promise<{
  reviews: CourseReview[];
  summary: CourseReviewSummary;
}> {
  const res = await httpClient.get<{
    data: { reviews: CourseReview[]; summary: CourseReviewSummary };
  }>(`/v1/courses/${courseId}/reviews`);
  return res.data.data;
}

export async function submitCourseReview(
  courseId: string,
  input: { rating: number; body?: string },
): Promise<void> {
  await httpClient.post(`/v1/courses/${courseId}/reviews`, input);
}
